<template>
  <div>
    <!-- <MTop title="视频列表" /> -->
    <!-- <MTop title="视频列表" />
    <div style="padding:10px 20px;">
      <el-input class="tac" clearable v-model="value" placeholder="请输入名称/标签/简介">
        <el-button @click="submitSearch" slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div>
      <ul class="list_ul">
        <li
          :class="[activeId == item.id ?'activedLi':'']"
          @click="selectTab(item.id)"
          v-for="item in topArray"
          :key="item.id"
        >
          <div style="font-size:20px;" :class="['iconfont', item.icon,item.color]"></div>

          <span style="font-weight: bold;font-size:14px;">{{item.name}}</span>
        </li>
      </ul>
    </div>-->
    <!-- 视频列表 -->
    <template>
      <!-- 列表 -->
      <div class="mob_list">
        <!-- 显示模式 -->
        <div v-show="isShowTab" class="topTab flex-row">
          <div class="ll" id="0" ref="single" @click="checkVideoMode">单视频</div>
          <div class="ll" id="1" ref="gather" @click="checkVideoMode">视频集</div>
        </div>
        <!-- 单视频 -->
        <ul v-if="showMode == 0 && newVideoList.length !== 0">
          <li
            @click="selectDetail(item.id)"
            class="top-li"
            v-for="(item,index) in newVideoList"
            :key="item.id"
          >
            <div class="li-img">
              <el-image fit="cover" :src="item.fileLocation"></el-image>
              <!-- <div
              :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
              >{{index + 1}}</div>-->
            </div>
            <div class="li-text">
              <h3 class="red">{{item.fileName}}</h3>
              <div class="f12">相关人物：{{item.personName}}</div>
              <div class="f12">上传人：{{item.createUser}}</div>
              <div
                class="text-color f12"
              >类别：{{item.videoType == 1 ?'成片库':'素材库'}} / 格式：{{item.fileType}}</div>
              <div class="text-color f12">时长：{{item.filePlayTime}}</div>
            </div>
          </li>
        </ul>
        <!-- 视频集 -->
        <div class="list-gather">
          <ul v-if="showMode == 1 && newVideoList.length !== 0">
            <li
              @click="selectDetail(item.id)"
              class="top-li"
              v-for="(item,index) in newVideoList"
              :key="item.id"
            >
              <div class="li-img">
                <el-image fit="cover" :src="item.imgUrl"></el-image>
                <!-- <div
              :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
                >{{index + 1}}</div>-->
              </div>
              <div class="li-text">
                <h3 class="red">{{item.title}}</h3>
                <div class="f12">相关人物：{{item.personName}}</div>
                <div
                  class="text-color f12"
                >类别：{{item.groupType == 1 ?'成片库':'素材库'}} / 格式：{{item.fileType}}</div>
                <!-- <div class="text-color f14">时长：{{item.filePlayTime}}</div> -->
              </div>
            </li>
          </ul>
        </div>

        <div v-if="newVideoList.length == 0" style="padding:30px;" class="tac">暂无相关搜索条件的数据</div>
      </div>
      <!-- 加载更多 -->
      <div v-if="isMoreLoad && newVideoList.length !== 0" class="padding-20 tac">
        <el-button @click="loadingMore" size="mini">{{loadMoreName}}</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: function() {
    return {
      isShowTab: true,
      activeId: 0,
      // value: "",
      topArray: [
        {
          id: 1,
          src: require("../../assets/img/icon/play.png"),
          name: "成片库",
          icon: "iconshipin",
          color: "one"
        },
        {
          id: 0,
          src: require("../../assets/img/icon/sucai.png"),
          name: "素材库",
          icon: "iconwenjianjia",
          color: "two"
        },
        {
          id: 2,
          src: require("../../assets/img/icon/size.png"),
          name: "高级搜索",
          icon: "iconsousuo",
          color: "three"
        }
      ],
      newVideoList: [],
      loadMoreName: "加载更多",
      isMoreLoad: true
    };
  },
  props: {
    searchVlaue: "",
    videoId: ""
  },
  computed: mapState({
    videoList: "videoList",
    showMode: "showMode",
    page: "page",
    highSearchData: "highSearchData",
    limit: 10
  }),
  methods: {
    checkedList: async function() {
      console.log(this.videoId);
      var res = await this.$http.get(
        `/v1/index/highSearch?page=${this.page}&limit=10&videoTypeId=${this.videoId}&retrieval=${this.searchVlaue}&status=${this.showMode}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        console.log(data);
        this.$store.state.highSearchData = data;
        if (this.searchVlaue) {
          if (this.newVideoList.length !== 0) {
            this.newVideoList = this.newVideoList.concat(data.recordList);
          } else {
            this.newVideoList = data.recordList;
          }
        } else {
          this.newVideoList = data.recordList;
        }
      }
    },
    loadingMore: function() {
      console.log(this.page);
      console.log(this.highSearchData);
      if (this.page < this.highSearchData.pageCount) {
        this.$store.state.page++;

        if (this.searchVlaue) {
          this.checkedList();
        } else {
          this.$store.dispatch("highSearch");
          setTimeout(() => {
            this.newVideoList = this.newVideoList.concat(this.videoList);
            this.$store.state.moreVideoList = this.newVideoList;
          }, 200);
        }

        console.log(this.newVideoList);
      } else {
        // console.log(this.page);
        // console.log(this.highSearchData.pageCount);
        this.$layer.toast({
          icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: "全部加载完毕",
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        });
        this.isMoreLoad = false;
        // this.$store.state.page = 1
      }
    },
    selectDetail: async function(id) {
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$router.push({
          path: "/mobvideodetail",
          query: {
            id: id,
            status: this.showMode
          }
        });
      } else {
        this.$layer.toast({
          icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: message,
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        });
      }
    },
    searchButtonVideoList: function() {
      this.newVideoList = [];
      this.checkedList();
    },
    checkVideoMode: function(e) {
      this.isMoreLoad = true;
      this.$store.state.page = 1;
      this.$store.state.showMode = e.target.id;
      // this.$store.dispatch("highSearch");
      this.newVideoList = [];
      if (this.searchVlaue) {
        this.checkedList();
      } else {
        // if (this.videoList.length !== 0) {
        //   this.$store.dispatch("highSearch");
        //   console.log(this.newVideoList);
        //   setTimeout(() => {
        //     this.newVideoList = JSON.parse(JSON.stringify(this.videoList));
        //     this.$store.state.moreVideoList = this.videoList;
        //   }, 500);
        // } else {
        //   this.checkedList();
        // }
        console.log(this.$store.state)
           this.$store.dispatch("highSearch");
          console.log(this.newVideoList);
          setTimeout(() => {
            this.newVideoList = JSON.parse(JSON.stringify(this.videoList));
            this.$store.state.moreVideoList = this.videoList;
          }, 500);
      }

      e.target.style =
        " background-color: #00aaff;color: #fff;font-size: 16px;";
      var tarId = e.target.id;
      if (tarId == 0) {
        this.$refs.gather.style = "";
      } else {
        this.$refs.single.style =
          "background-color:#fff;color:#555;font-size:14px;";
      }
    }
  },
  mounted: function() {
    this.$emit("func", "视频列表");

    // this.$store.state.page = 1
    console.log(this.$store.state.page);

    if (this.showMode == 0) {
      this.$refs.gather.style =
        "background-color:#fff;color:#555;font-size:14px;";
      this.$refs.single.style =
        "background-color: #00aaff;color: #fff;font-size: 16px;";
    } else {
      this.$refs.single.style =
        "background-color:#fff;color:#555;font-size:14px;";
      this.$refs.gather.style =
        "background-color: #00aaff;color: #fff;font-size: 16px;";
    }
    if (this.$route.query.value) {
      this.value = this.$route.query.value;
    }
    document.querySelector("#app").scrollIntoView(true);
  },
  watch: {
    "$store.state.videoList": {
      handler: function(newVlaue, oldValue) {
        // console.log('newValue',newVlaue)
        // this.newVideoList = this.$store.state.videoList
      },
      deep: true
    },
    // '$store.state.page':function(){
    //   this.$store.dispatch("highSearch");
    //    this.newVideoList = this.newVideoList.concat(this.videoList);
    // }
    videoList: {
      handler: function(newValue, oldValue) {
        this.newVideoList = JSON.parse(JSON.stringify(this.videoList));
      },
      deep: true
    }
  },
  beforeDestroy: function() {
    // this.$store.state.showMode = 0;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == "/highsearch") {
        vm.newVideoList =JSON.parse(JSON.stringify(vm.videoList)) ;
        vm.$store.state.moreVideoList =JSON.parse(JSON.stringify(vm.videoList)) ;
      } else {
        if (vm.searchVlaue) {
          vm.checkedList();
        } else {
          vm.newVideoList = vm.$store.state.moreVideoList;
          console.log(vm.newVideoList);
        }
      }
    });
  }
};
</script>

<style scoped lang="scss">
.one {
  color: #2d98fe;
}
.two {
  color: #2cd9c5;
}
.three {
  color: #00aaff;
}
.activedLi {
  border: 2px solid red !important;
}
.list_ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #fff;
  padding: 15px;
  li {
    border: 1px solid #eaeaea;
    display: flex;
    flex-direction: column;
    padding: 5px 25px;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    // font-weight: bold;
  }
}
.mob_list {
  background-color: #fff;
  margin-top: 20px;
  .top-li {
    display: flex;
    flex-direction: row;
    padding: 20px 10px;
    border-bottom: 1px solid #dddddd;
    margin: 0px 10px;
    .li-img {
      position: relative;
      .li-num {
        width: 30px;
        height: 26px;
        border-radius: 5px 0 5px 0;
        // background-color: #f5a623;
        // background-color: #c1c7ce;

        left: 0px;
        top: 0px;
        position: absolute;
        text-align: center;
        color: #fff;
        font-size: 20px;
      }
    }
    .el-image {
      width: 135px;
      height: 96px;
      border-radius: 5px;
    }
    .li-text {
      padding: 0 10px;
      h3 {
        text-align: left;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .topTab {
    justify-content: space-around;
    border-bottom: 1px solid #eaeaea;
    // padding: 0px 20px;
    text-align: center;

    .ll {
      width: 100%;
      padding: 10px 20px;
      cursor: pointer;
      font-size: 14px;
      color: #555;
    }
    .ll:first-child {
      background-color: #00aaff;
      color: #fff;
      font-size: 16px;
    }
  }
  // 视频集
  .list-gather {
    .top-li {
      display: flex;
      flex-direction: row;
      padding: 20px 10px;
      border-bottom: 1px solid #dddddd;
      margin: 0px 10px;
      .li-img {
        box-shadow: -10px 10px 2px #d7d7d7;
        border-radius: 5px;
        position: relative;
        .li-num {
          width: 30px;
          height: 26px;
          border-radius: 5px 0 5px 0;
          // background-color: #f5a623;
          // background-color: #c1c7ce;

          left: 0px;
          top: 0px;
          position: absolute;
          text-align: center;
          color: #fff;
          font-size: 20px;
        }
      }
      .el-image {
        width: 135px;
        height: 96px;
        border-radius: 5px;
        box-shadow: -5px 5px 1px #969696;
      }
      .li-text {
        padding: 0 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/videolist.vue